import * as cn from "classnames";
import * as React from "react";
import * as styles from "./styles.css";
var Ad = function (_a) {
    var children = _a.children, id = _a.id, className = _a.className, style = _a.style;
    return (React.createElement("div", { id: id, className: cn(styles.ad, className), style: style },
        React.createElement("div", { className: styles.adLabel }, "Advertisement"),
        children));
};
export default Ad;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/ad/index.tsx
// module id = LlzR
// module chunks = 2